<script setup lang="ts">
import { faCheck, faTimes, faGear } from '@fortawesome/pro-light-svg-icons';

import TeemillSpinner from './TeemillSpinner.vue';
import { useLoadingState } from '../loading';
import { FontAwesomeIcon } from '@teemill/components';

const { states } = useLoadingState();
const isDevelopment = import.meta.env.DEV;

/**
 * Filter out all loading states except the next one
 */
const displayStates = states;
// const displayStates = computed(() =>
//   states.value.slice(
//     0,
//     states.value.findIndex(item => !item.ready) + 1 || states.value.length
//   )
// );
</script>

<template>
  <div class="relative flex justify-center items-center min-h-screen">
    <div class="text-center">
      <TeemillSpinner />
    </div>
    <div v-if="isDevelopment" class="absolute top-3 left-3 text-xs">
      <p v-for="state in displayStates" :key="state.name" class="mb-2">
        <FontAwesomeIcon
          class="mr-1"
          :spin="!state.ready"
          :icon="state.ready ? (state.value === undefined ? faTimes : faCheck) : faGear"
        />
        {{ state.name }}<template v-if="state.ready"> - {{ state.value }} </template>
      </p>
    </div>
  </div>
</template>
